
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * OrderTimeInForce enum
 */
class OrderTimeInForce {
  /**
   * Initialize enum with a given value
   * @param {OrderTimeInForce|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof OrderTimeInForce) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!OrderTimeInForce}
   * @param {!OrderTimeInForce} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrderTimeInForce)) {
      throw new TypeError('Instance of OrderTimeInForce is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!OrderTimeInForce}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!OrderTimeInForce}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === OrderTimeInForce.GTC.value) {
      return 'GTC'
    }
    if (this.value === OrderTimeInForce.IOC.value) {
      return 'IOC'
    }
    if (this.value === OrderTimeInForce.FOK.value) {
      return 'FOK'
    }
    if (this.value === OrderTimeInForce.DAY.value) {
      return 'DAY'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!OrderTimeInForce}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!OrderTimeInForce}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!OrderTimeInForce} Created enum
   */
  static fromObject (other) {
    return new OrderTimeInForce(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
OrderTimeInForce.GTC = new OrderTimeInForce(0 + 0)
// noinspection PointlessArithmeticExpressionJS
OrderTimeInForce.IOC = new OrderTimeInForce(0 + 1)
// noinspection PointlessArithmeticExpressionJS
OrderTimeInForce.FOK = new OrderTimeInForce(0 + 2)
// noinspection PointlessArithmeticExpressionJS
OrderTimeInForce.DAY = new OrderTimeInForce(0 + 3)

export { OrderTimeInForce };

/**
 * Fast Binary Encoding OrderTimeInForce field model
 */
class FieldModelOrderTimeInForce extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelOrderTimeInForce}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelOrderTimeInForce}
   * @param {OrderTimeInForce=} defaults Default value, defaults is new OrderTimeInForce()
   * @returns {!OrderTimeInForce} Result value
   */
  get (defaults = new OrderTimeInForce()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new OrderTimeInForce(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelOrderTimeInForce}
   * @param {!OrderTimeInForce} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelOrderTimeInForce };
